import ProfitLossReportEditResultConfigController from './edit_config_controller/ProfitLossReportEditResultConfigController'
import OldReportMediator from './OldReportMediator'
import {ReportType} from './constants'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'

export default function ProfitLossReportMediator ()
{
    this.constructor = ProfitLossReportMediator;
}

ProfitLossReportMediator.prototype = new OldReportMediator();

ProfitLossReportMediator.prototype.init = function ( config )
{
    OldReportMediator.prototype.init.call(this, config);

    return this;
};

ProfitLossReportMediator.prototype.getReportType = function()
{
    return ReportType.PROFIT_LOSS;
};

ProfitLossReportMediator.prototype.initEditConfigController = function( config )
{
    var self = this;
    return new ProfitLossReportEditResultConfigController().init(
            {
                reportParameters:config.reportParameters,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: function(){ self.changeParametersCallback(); }
            } );
};

ProfitLossReportMediator.prototype._populateHeadersArray = function( headersArray ) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray( this.reportParameters.customersProjectsSelection, headersArray ); //customers and projects
};

ProfitLossReportMediator.prototype.initPrintableHeadersBuilder = function ( config ) {
    return new ReportPrintableHeadersBuilder().init(
            {
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                isFilteredByAssignments: config.isFilteredByAssignments
            }
    );
};



// WEBPACK FOOTER //
// ./web/js/reports/ProfitLossReportMediator.js